module.exports = __webpack_public_path__ + "static/media/mail-contrast.4271ada1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mail-contrast.svg
// module id = 740
// module chunks = 0